let fallbackSequence = 0;

// These IDs deduplicate analytics deliveries; they are not security tokens.
export const createEventId = (eventName: string) => {
  try {
    if (
      typeof crypto !== 'undefined' &&
      typeof crypto.randomUUID === 'function'
    ) {
      return `${eventName}.${crypto.randomUUID()}`;
    }
  } catch {
    // Some embedded browsers expose Web Crypto but reject its calls.
  }

  try {
    if (
      typeof crypto !== 'undefined' &&
      typeof crypto.getRandomValues === 'function'
    ) {
      const bytes = crypto.getRandomValues(new Uint8Array(16));
      bytes[6] = (bytes[6] & 0x0f) | 0x40;
      bytes[8] = (bytes[8] & 0x3f) | 0x80;
      const hex = Array.from(bytes, (byte) =>
        byte.toString(16).padStart(2, '0'),
      );
      const uuid = [
        hex.slice(0, 4).join(''),
        hex.slice(4, 6).join(''),
        hex.slice(6, 8).join(''),
        hex.slice(8, 10).join(''),
        hex.slice(10).join(''),
      ].join('-');
      return `${eventName}.${uuid}`;
    }
  } catch {
    // Keep analytics working even when Web Crypto is unavailable entirely.
  }

  fallbackSequence += 1;
  return `${eventName}.${Date.now().toString(36)}-${fallbackSequence.toString(36)}-${Math.random().toString(36).slice(2)}`;
};
